import * as React from 'react';
import classNames from 'classnames';
import * as buttonStyles from '../../styles/button.css';
import * as styles from './SocialExpandButton.css';
export var SocialExpandButton = function SocialExpandButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: classNames(buttonStyles['button'], styles['show-more']),
    title: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0451",
    type: "button",
    "data-mark": "SocialExpandBtn",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null));
};